const environment = {
  //apiUrl: "https://optimisticwebapis.azurewebsites.net/api/",
  apiUrl: "https://optimisticwebapis-dotnet8-eaapgpcndtaeeud4.southeastasia-01.azurewebsites.net/api/v1/", //dontnet8
  //apiUrl: "https://localhost:44376/api/v1/",
  //apiUrl:'https://optimisticstagingwebapi.azurewebsites.net/api/'
};
export default environment;
